import styled from 'styled-components';

/**
 * Full-screen boot surface — use only before the router shell exists (Okta init,
 * first AppShell chunk). Route transitions should use `RouteContentSkeleton`
 * inside `RouterShell` so the sidebar stays visible.
 */
export const BootTransitionSurface = styled.div`
  position: fixed;
  inset: 0;
  z-index: 9998;
  background-color: #ececec;
`;
